<template>
  <v-card flat class="d-flex flex-wrap justify-center align-center px-3" style="gap: 8px;">
    <v-card v-for="(label, index) in ['days', 'hours', 'minutes', 'seconds']" :key="index" color="primary">
      <v-card-text class="text-center white--text px-2 py-1">
        <div class="text-h4 font-weight-bold" style="line-height: 0.8em;">{{ getTimeRemaining[label] }}</div>
        <div class="text-body-1 font-weight-bold text-uppercase">{{ label }}</div>
      </v-card-text>
    </v-card>
  </v-card>
</template>

<script>
export default {
  name: "CountdownTimer",
  props: {
    targetDateTime: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      timeRemaining: {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
      },
    };
  },
  computed: {
    getTimeRemaining() {
      return this.timeRemaining;
    },
  },
  methods: {
    updateCountdown() {
      const now = new Date();
      const target = new Date(this.targetDateTime);
      if (target > now) {
        const diff = Math.floor((target - now) / 1000);
        this.timeRemaining.days = String(Math.floor(diff / (3600 * 24))).padStart(2, '0');
        this.timeRemaining.hours = String(Math.floor((diff % (3600 * 24)) / 3600)).padStart(2, '0');
        this.timeRemaining.minutes = String(Math.floor((diff % 3600) / 60)).padStart(2, '0');
        this.timeRemaining.seconds = String(diff % 60).padStart(2, '0');
      } else {
        this.timeRemaining = { days: '00', hours: '00', minutes: '00', seconds: '00' };
      }
    },
  },
  mounted() {
    this.updateCountdown();
    this.interval = setInterval(this.updateCountdown, 1000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
};
</script>

<style scoped>
.v-card {
  min-width: 80px;
  text-align: center;
}
</style>